/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AgeassuranceDefs from './defs.defs'

const $nsid = 'app.bsky.ageassurance.getState'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  regionCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  countryCode: /*#__PURE__*/ l.string(),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  state: /*#__PURE__*/ l.ref<AgeassuranceDefs.State>(
    (() => AgeassuranceDefs.state) as any,
  ),
  metadata: /*#__PURE__*/ l.ref<AgeassuranceDefs.StateMetadata>(
    (() => AgeassuranceDefs.stateMetadata) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns server-computed Age Assurance state, if available, and any additional metadata needed to compute Age Assurance state client-side. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
